module.exports = __webpack_public_path__ + "img/900681978.029e5581.png";